import React from "react";

import { Box, TypographyBlock, useThemeProps } from "../../wsui/base";

export default function FormModuleCustomContentField(props) {
  props = useThemeProps({ props, name: "FormModuleCustomContentField" });
  let {
    field: {
      content,
      // conditionalLogic,
      // conditonalField,
    },
    as: Component = Box,
    ...restProps
  } = props;
  return (
    <Component {...restProps}>
      <TypographyBlock>{content}</TypographyBlock>
    </Component>
  );
}
